// Empty module shim for optional Node-only dependencies.
module.exports = {};
